import { render, staticRenderFns } from "./popupType.vue?vue&type=template&id=186e3002"
import script from "./popupType.vue?vue&type=script&lang=js"
export * from "./popupType.vue?vue&type=script&lang=js"
import style0 from "./popupType.vue?vue&type=style&index=0&id=186e3002&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports